/**
 * Purpose: Inline SVG checklist icons and section colors for the live recording modal (dev-handoff parity).
 * Inputs: N/A (static exports)
 * Output: SECTION_COLORS map, SECTION_ICONS map (React nodes)
 * Side effects: None
 *
 * Copied from dev-handoff/react/components/icons.js for exact design match.
 */
import React from "react";

export const SECTION_COLORS = {
  cc: "#2563EB",
  hx: "#7C5BBF",
  exam: "#0E9AA7",
  orders: "#E08A2B",
  assess: "#DC2626",
  proc: "#0F766E",
  work: "#5b5fc7",
  dc: "#16A34A",
};

export const SECTION_ICONS = {
  cc: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <rect x="7" y="4" width="10" height="16" rx="2" />
      <path d="M9 4v2h6V4" />
      <path d="M10 11h4M10 15h4" />
    </svg>
  ),
  hx: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  exam: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  orders: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <path d="M4 6h14M4 12h14M4 18h10" />
      <circle cx="20" cy="18" r="2" fill="currentColor" />
    </svg>
  ),
  assess: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
      <path d="M3 12h3l2-5 4 10 2-5h7" />
    </svg>
  ),
  proc: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <path d="M4 20l4-1 10-10-3-3L5 16l-1 4z" />
      <path d="M13 6l3 3" />
    </svg>
  ),
  work: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <path d="M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z" />
    </svg>
  ),
  dc: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
      <path d="M5 21V4l7 3 7-3v17" />
    </svg>
  ),
};

/** Billing/documentation checklist sections for voice-first modal (HPI → MDM). */
export const CLINICAL_SECTION_COLORS = {
  hpi: "#2563EB",
  exam: "#0E9AA7",
  assessment: "#DC2626",
  plan: "#16A34A",
  mdm: "#7C5BBF",
};

export const CLINICAL_SECTION_ICONS = {
  hpi: SECTION_ICONS.cc,
  exam: SECTION_ICONS.exam,
  assessment: SECTION_ICONS.assess,
  plan: SECTION_ICONS.dc,
  mdm: SECTION_ICONS.hx,
};
